import { IonIcon } from "@ionic/react";
import "./OfflineTabsHeader.css";
import {
  bagHandleOutline,
  bagHandleSharp,
  cogOutline,
  cogSharp,
} from "ionicons/icons";

export type OfflineTab = "work" | "equipment";

type Props = {
  active: OfflineTab;
  onChange: (tab: OfflineTab) => void;
};

export default function OfflineTabsHeader({ active, onChange }: Props) {
  return (
    <div className="tabs-header">
      <div
        className={`tab-btn ${active === "work" ? "active" : ""}`}
        onClick={() => onChange("work")}
      >
        <IonIcon ios={bagHandleOutline} md={bagHandleSharp} />
        <span>Work Orders</span>
      </div>

      <div
        className={`tab-btn ${active === "equipment" ? "active" : ""}`}
        onClick={() => onChange("equipment")}
      >
        <IonIcon ios={cogOutline} md={cogSharp} />
        <span>Equipment</span>
      </div>
    </div>
  );
}
